import React, { type FunctionComponent } from 'react';
import Modal from '@fff-web/fff-ui-shared/Modal';
import { UpdatePaymentFormV2Container } from './UpdatePaymentFormV2/UpdatePaymentFormV2Container';
import styles from './UpdatePaymentModalV2.module.css';

interface UpdatePaymentModalV2Props {
  isOpen: boolean;
  onClose: () => void;
  onSuccess: () => void;
  subtitle: string;
}

type BodyProps = Omit<UpdatePaymentModalV2Props, 'isOpen'>;

export const MODAL_TITLE = 'Update Payment Method';

const UpdatePaymentModalV2: FunctionComponent<UpdatePaymentModalV2Props> = ({
  isOpen,
  onClose,
  onSuccess,
  subtitle,
}) => {
  if (!isOpen) return null;

  return (
    <Modal isOpen={isOpen} onRequestClose={onClose} className={styles.container}>
      <Header onClose={onClose} />
      <Body onSuccess={onSuccess} subtitle={subtitle} onClose={onClose} />
    </Modal>
  );
};

const Body = ({ onSuccess, subtitle, onClose }: BodyProps) => (
  <div className={styles.body}>
    <p className={styles.subtitle}>{subtitle}</p>
    <UpdatePaymentFormV2Container onSuccess={onSuccess} onClose={onClose} />
  </div>
);

const Header = ({ onClose }: { onClose: () => void }) => (
  <div className={styles.header}>
    <h3>{MODAL_TITLE}</h3>
    <CloseIcon onClose={onClose} />
  </div>
);

const CloseIcon = ({ onClose }: { onClose: () => void }) => (
  <div role="button" onClick={onClose} aria-label="Close modal" className={styles.closeButton}>
    <i className="fa fa-times" aria-hidden="true" />
  </div>
);

export default UpdatePaymentModalV2;
